import { isMobile, isInDashboard } from './utils'

class Toast {
  static instance = null
  
  toasts = []
  options
  hasAboveToast = false
  toastGap = 16 // toast 之间的间距
  baseTopOffset = 20 // 第一个 toast 距离顶部的距离

  constructor() {
    // 单例模式
    if (Toast.instance) {
      return Toast.instance
    }
    
    this.options = {
      color: 'primary',
      stacking: true,
      hidden: false,
      autohide: true,
      width: '450px',
      position: 'top-right',
      delay: 3000
    }
    
    Toast.instance = this
  }

  // changeOptions(custom) {
  //   this.options = custom
  // }

  /** 更新所有 toast 的位置 */
  updateToastsPosition() {
    let currentTop = this.baseTopOffset
    
    // 从最新的 toast 开始(数组末尾),最新的在最上面
    for (let i = this.toasts.length - 1; i >= 0; i--) {
      const toast = this.toasts[i]
      if (toast && toast.parentElement) {
        toast.style.setProperty('top', `${currentTop}px`, 'important')
        toast.style.transition = 'top 0.3s ease, opacity 0.3s ease'
        
        const toastHeight = toast.getBoundingClientRect().height || toast.offsetHeight || 60
        currentTop += toastHeight + this.toastGap
      }
    }
  }

  /** Adds a new alert to the DOM and toasts
   * @returns index of this newly created alert in toasts array
   */
  makeNew(textColor = 'white', isAbove = false, currentCallback) {
    if (isAbove) {
      this.flush(false)
      this.hasAboveToast = true
    } else if (this.hasAboveToast) {
      return undefined
    }
    // 移除原来的 flush() 调用,允许多个 toast 共存

    let a = document.createElement('div')
    a.innerHTML = `<div class="toast-body max-w-[700px]">-</div>`

    const uuid = Math.random().toString(36).substring(2, 6)
    const toastClass = `toast-${uuid}`
    a.classList.add(
      'toast',
      'fade',
      'position-fixed',
      'left-0',
      'right-0',
      'mx-auto',
      toastClass
    )
    
    const zIndex = isAbove ? 10000 : 9999
    // 重要：使用 !important 覆盖 mdb 的默认样式，并设置初始位置
    a.style.cssText = `z-index:${zIndex};max-width:max-content;--mdb-toast-max-width:inherit;top:${this.baseTopOffset}px !important;`
    
    if (textColor) a.classList.add(textColor)

    if (document.querySelector(`.${toastClass}`)) {
      return
    }

    document.body.appendChild(a)
    
    if (isAbove) {
      a.setAttribute('data-above', 'true')
    }
    
    if (currentCallback) {
      a.setAttribute('data-has-callback', 'true')
      a._callback = currentCallback
    }
    
    let index = this.toasts.push(a)
    return index - 1
  }

  hasToast() {
    // 检查是否有非 above 的 toast
    return this.toasts.some(toast => !toast.hasAttribute('data-above'))
  }
  
  executeCallback(callback) {
    if (typeof callback === 'function') {
      try {
        callback()
      } catch (e) {
        console.error('Error executing toast callback:', e)
      }
    }
  }

  // yellow/orange alert
  toast(type = 'warning', text, title = false, customOptions) {
    if (!text) {
      return
    }
    const isAbove = customOptions?.above === true

    if (this.hasAboveToast && !isAbove) {
      return
    }

    // 检查是否已存在相同内容的 toast
    const existingToast = this.toasts.find(toast => {
      const toastBodyText = toast.querySelector('.toast-body-text')
      return toastBodyText && toastBodyText.innerHTML === text
    })
    
    if (existingToast) {
      return
    }

    // if there is called on mobile, just show alert
    if (isMobile()) {
      alert(text)
      if (customOptions?.callback) {
        this.executeCallback(customOptions.callback)
      }
      return
    }

    const dashboardEl = document.querySelector('.dashboard-body')
    const isDashboardHidden = dashboardEl?.classList.contains('d-none')
    if (isInDashboard && isDashboardHidden) {
      dashboardEl.classList.remove('d-none')
    }

    const colors = {
      warning: 'toast-warning',
      info: 'toast-info',
      success: 'toast-success',
      danger: 'toast-danger'
    }
    
    const currentCallback = customOptions?.callback
    
    let toastIndex = this.makeNew(colors[type], isAbove, currentCallback)
    if (toastIndex === undefined) return
    
    // 直接使用索引获取刚创建的 toast 元素
    const currentToast = this.toasts[toastIndex]
    if (!currentToast) {
      console.error('Toast 创建失败')
      return
    }

    let options = {
      color: 'warning',
      stacking: false,
      hidden: false,
      autohide: true,
      width: '450px',
      position: 'center',
      delay: 3000,
      closeable: false,
      ...customOptions
    }
    options.autohide = customOptions?.closeable ? false : (customOptions?.autohide ?? true)
    
    const closeBtn = `<button type="button" style="width: 1rem; height: 1rem;border: none; background: none; padding: 0; cursor: pointer; width: 16px; height: 16px;" data-mdb-dismiss="toast" aria-label="Close">
      <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8.25" fill="#DF9C5E"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.95113 5.95064C6.18544 5.71632 6.56534 5.71632 6.79966 5.95064L9.00039 8.15139L11.2011 5.95064C11.4354 5.71632 11.8153 5.71632 12.0497 5.95064C12.284 6.18495 12.284 6.56485 12.0497 6.79917L9.84892 8.99992L12.0497 11.2007C12.284 11.435 12.284 11.8149 12.0497 12.0492C11.8153 12.2835 11.4354 12.2835 11.2011 12.0492L9.00039 9.84845L6.79966 12.0492C6.56534 12.2835 6.18544 12.2835 5.95113 12.0492C5.71681 11.8149 5.71681 11.435 5.95113 11.2007L8.15187 8.99992L5.95113 6.79917C5.71681 6.56485 5.71681 6.18495 5.95113 5.95064Z" fill="white"/>
      </svg>
    </button>`
    
    const toastBody = currentToast.querySelector('.toast-body')
    if (toastBody) {

      toastBody.innerHTML = `<div class="toast-body-text" style="word-break: break-all;">${text}</div>`
      toastBody.style.display = 'flex'
      toastBody.style.gap = '1.25rem'
    }
    
    if (options.closeable) {
      toastBody.insertAdjacentHTML('beforeend', closeBtn)
    }

    let alertInstance = new mdb.Toast(currentToast, options)
    if (alertInstance._element && alertInstance._element.innerText !== '-') {
      alertInstance.show()
    }

    const self = this
    const isAboveToast = currentToast.hasAttribute('data-above')
    
    // 监听 toast 显示完成事件，更新位置
    currentToast.addEventListener('shown.mdb.toast', function onShown() {
      self.updateToastsPosition()
      currentToast.removeEventListener('shown.mdb.toast', onShown)
    })
    
    // 备用：延迟更新位置
    setTimeout(() => self.updateToastsPosition(), 300)
    
    currentToast.addEventListener('hidden.mdb.toast', function () {
      if (isAboveToast) {
        self.hasAboveToast = false
      }
      
      const index = self.toasts.indexOf(currentToast)
      if (index > -1) {
        self.toasts.splice(index, 1)
      }
      
      if (this._callback) {
        self.executeCallback(this._callback)
      }
      
      this.remove()
      self.updateToastsPosition()
    })
  }

  /** Wipe all toasts from DOM */
  flush() {
    this.toasts.forEach(a => a.remove())
    this.toasts = []
  }
}

export default Toast
